import React, { useEffect, useMemo, useRef } from 'react';

import { PropTypes } from 'prop-types';
import useDataFetch from '../../../../hooks/useDataFetch';
import storePropTypes from '../../../../redux/store/propTypes';
import { getHttpHeader } from '../../../../util/FetchTools';

function PlayoutService({ userId, url, orgaHash, cancelToken, onResult }) {
   const body = userId;
   const header = useMemo(() => getHttpHeader(orgaHash), [orgaHash]);

   const { successful, isLoading, errorMessage, httpStatus, data } = useDataFetch(url, {
      method: 'POST',
      body,
      header,
      cancelToken,
   });

   // Held in a ref because the parent re-creates it every render, and called from an effect because it sets parent state.
   const onResultRef = useRef(onResult);
   onResultRef.current = onResult;

   useEffect(() => {
      if (successful) {
         onResultRef.current({ isLoading, httpStatus, untouched: false, data: data.result });
      } else if (errorMessage) {
         onResultRef.current({ isLoading, error: errorMessage, untouched: false });
      } else {
         onResultRef.current({ untouched: true, isLoading });
      }
   }, [successful, isLoading, errorMessage, httpStatus, data]);

   return <></>;
}

PlayoutService.propTypes = {
   userId: PropTypes.object,
   url: PropTypes.string,
   orgaHash: PropTypes.string,
   cancelToken: storePropTypes.cancelToken,
   onResult: PropTypes.func,
};

export default PlayoutService;
